import { ExpandMore, Language } from "@mui/icons-material";
import { Button, ListItemText, Menu, MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { withFirebase } from "../Firebase";

const SUPPORTED_LANGUAGES = ["es", "en", "it"];

const LangSelect = ({ icon, firebase }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const { t, i18n } = useTranslation();

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onChangeLanguaje = async (lang) => {
    setAnchorEl(null);

    if (!SUPPORTED_LANGUAGES.includes(lang)) {
      return;
    }

    try {
      /*
       * Si existe un usuario autenticado, primero guardamos
       * el idioma en PostgreSQL.
       */
      if (firebase.currentUser()) {
        await firebase.updateUserLanguage(lang);
      }

      /*
       * Si no hay usuario autenticado (por ejemplo durante
       * el registro), simplemente cambiamos el idioma de
       * la interfaz. Ese idioma se enviará cuando se registre.
       */
      await i18n.changeLanguage(lang);
    } catch (error) {
      console.error("Error actualizando el idioma del usuario:", error);
    }
  };

  useEffect(() => {
    /*
     * Cuando Firebase detecta un usuario autenticado,
     * recuperamos sus datos de PostgreSQL y aplicamos
     * el idioma que tenga guardado.
     */
    const unsubscribe = firebase.auth.onAuthStateChanged((authUser) => {
      if (!authUser) {
        return;
      }

      firebase
        .getUserDeviceList()
        .then((data) => {
          const savedLanguage = data?.user?.idioma;

          if (SUPPORTED_LANGUAGES.includes(savedLanguage)) {
            i18n.changeLanguage(savedLanguage);
          }
        })
        .catch((error) => {
          console.error(
            "Error recuperando el idioma del usuario:",
            error
          );
        });
    });

    return () => {
      unsubscribe();
    };
  }, [firebase, i18n]);

  return (
    <>
      <Button
        aria-label="account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        type="text"
        onClick={handleMenu}
        color="inherit"
      >
        {icon && <Language style={{ marginRight: 6 }} />}
        {t("navigation.languaje.current")}
        <ExpandMore />
      </Button>

      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          button
          onClick={() => onChangeLanguaje("es")}
        >
          <ListItemText>
            {t("navigation.languaje.es")}
          </ListItemText>
        </MenuItem>

        <MenuItem
          button
          onClick={() => onChangeLanguaje("en")}
        >
          <ListItemText>
            {t("navigation.languaje.en")}
          </ListItemText>
        </MenuItem>

        <MenuItem
          button
          onClick={() => onChangeLanguaje("it")}
        >
          <ListItemText>
            {t("navigation.languaje.it")}
          </ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default withFirebase(LangSelect);